import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=a54e79c0"
import script from "../controllers/privacy-policy.js?vue&type=script&lang=js&external"
export * from "../controllers/privacy-policy.js?vue&type=script&lang=js&external"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=a54e79c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports